

export const deleteSlash = (str) => {
    return str.endsWith('/') ? str.slice(0, -1) : str;
}